import cabri from "./cabri-app";

class FileDropper {

    constructor (canvas) {
        this.init(canvas);
    }

    init (canvas) {
        this.canvas = canvas;
        this.openIcon = null;
        canvas.parentElement.removeEventListener("dragover", this);
        canvas.parentElement.removeEventListener("dragleave", this);
        canvas.parentElement.removeEventListener("drop", this);
        canvas.parentElement.addEventListener("dragover", this);
        canvas.parentElement.addEventListener("dragleave", this);
        canvas.parentElement.addEventListener("drop", this);
    }

    async handleEvent (evt) {
        if (evt.type === "dragover" || evt.type === "dragleave") {
            this.FileDragHover(evt);
        }
        else
            if (evt.type === "drop") {
                await this.FileSelectHandler(evt);
            }
    }

    FileDragHover (e) {
        e.stopPropagation();
        e.preventDefault();
        if (e.type === "dragover") {
            // TODO: move to a CSS file
            this.canvas.style.boxSizing = "border-box";
            this.canvas.style.border = "lightpink solid 10px";
        }
        else {
            this.canvas.style.border = "none";
        }
    }

    async FileSelectHandler (e) {
        this.FileDragHover(e);
        let files = e.target.files || e.dataTransfer.files;
        console.log(files);
        let file = files[0];
        console.log(
            "<p>File information: <strong>" + file.name +
            "</strong> type: <strong>" + file.type +
            "</strong> size: <strong>" + file.size +
            "</strong> bytes</p>",
        );
        await this.Read(file);
    }

    async Read (file) {
        window.titleOfFile = file.name;
        let url = window.URL.createObjectURL(file);
        console.log("requesting url ", url);
        await cabri.resetWithUrl(url);
        this.init(cabri.canvas);
    }
}

export default FileDropper;
